import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NavBarView from './NavBar.view';
import { useDispatch } from 'react-redux';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { resetUsersStateAction } from '../../store/reducers/users';
import { resetRewardsStateAction } from '../../store/reducers/rewards';
import { resetDealsStateAction } from '../../store/reducers/deals';
import { useCurrentUserStore } from '../../store/zustand/useCurrentUserStore';
import { useQueryClient } from '@tanstack/react-query';
import useLeaderboardStore from '../../store/zustand/useLeaderboardStore';
import useOrgStore from '../../store/zustand/useOrgStore';
import { apiSlice } from '../../store/api/GraphQlQuery';

const NavBarContainer: React.FC = () => {
  const { signOut } = useAuthenticator((context) => [context.signOut]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryClient = useQueryClient();
  // const [isProfileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>(location.pathname);

  // const handleProfileClick = () => {
  //   setProfileDropdownOpen(!isProfileDropdownOpen);
  // };

  const { resetStore: resetCurrentUserStore } = useCurrentUserStore();
  const { resetStore: resetLeaderboardStore } = useLeaderboardStore();
  const { resetStore: resetOrgStore } = useOrgStore();

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavigate = (path: string) => {
    if (path === '/signout') {
      signOut();
      return;
    }

    setActiveTab(path);
    // setProfileDropdownOpen(false);
    setAnchorEl(null);
    setIsMobileMenuOpen(false);

    navigate(path);
  };

  const handleSignout = () => {
    resetLeaderboardStore();
    resetOrgStore();
    signOut();
    dispatch(resetUsersStateAction());
    dispatch(resetRewardsStateAction());
    dispatch(resetDealsStateAction());
    dispatch(apiSlice.util.resetApiState());
    // current user store needs to be reset on sign out for keeping permissions updated
    resetCurrentUserStore();

    // Clear all global cached state so it doesn't leak across accounts
    const g = global as any;
    g.me = undefined;
    g.appSettings = undefined;
    g.trainingVideos = undefined;
    g.notifications = 0;
    g.notificationCount = 0;
    g.refreshOnNotificationHandler = [];
    g.updateNotificationHandler = [];

    // Clear all react-query cache so no stale data persists
    queryClient.clear();

    navigate('/');
  };

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);

  return (
    <NavBarView
      activeTab={activeTab}
      // isProfileDropdownOpen={isProfileDropdownOpen}
      // handleProfileClick={handleProfileClick}
      anchorEl={anchorEl}
      setAnchorEl={setAnchorEl}
      handleNavigate={handleNavigate}
      // handleLeaderboardsMenuToggle={handleLeaderboardsMenuToggle}
      handleMobileMenuToggle={handleMobileMenuToggle}
      handleSignout={handleSignout}
      isMobileMenuOpen={isMobileMenuOpen}
    />
  );
};

export default NavBarContainer;
